import React from "react"
import {DatePicker} from "antd"
import dayjs, {Dayjs} from 'dayjs'
import 'dayjs/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU'
import classes from "./CustomRangePicker.module.scss"
import "./CustomRangePicker.scss"

interface ICustomRangePickerProps {
  className?: string
  label?: string
  value?: [Dayjs, Dayjs]
  dateFormat?: string
  errorMessage?: string
  onChangeDate?: any
  curDates?: [string, string] | null
}

function CustomRangePicker({className, label, dateFormat = "DD.MM.YYYY", errorMessage, onChangeDate, curDates, ...rest}: ICustomRangePickerProps) {

  const { RangePicker } = DatePicker

  let cls = [classes.wrap]

  if (className) {
    cls = [...cls, className]
  }

  const labelTemplate = label ? <label className={classes.label}>{label}</label> : null
  const errorMessageTemplate = errorMessage && <span className={classes.error_message}>{errorMessage}</span>

  const serverDateFormat = "YYYY-MM-DD"

  if (curDates) {
    rest.value = [dayjs(curDates[0], serverDateFormat), dayjs(curDates[1], serverDateFormat)]
  }

  return (
    <div className={cls.join(" ")}>
      <div className={classes.container}>
        {labelTemplate}
        <RangePicker
          format={dateFormat}
          locale={locale}
          className={"ant-range-picker-custom"}
          placeholder={["От", "До"]}
          onChange={values => {
            if (values) {
              onChangeDate([values[0]?.format(serverDateFormat), values[1]?.format(serverDateFormat)])
            } else {
              onChangeDate(null)
            }
          }}
          {...rest}
        />
      </div>
      {errorMessageTemplate}
    </div>
  )
}

export default CustomRangePicker